// src/components/PaymentRequiredModal.tsx
import React from 'react';
import { X } from 'lucide-react';

interface PaymentRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PaymentRequiredModal: React.FC<PaymentRequiredModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button style={styles.closeButton} onClick={onClose}>
          <X size={20} />
        </button>
        <div style={styles.icon}>
          <img
            src="/images/payment-required.png"
            alt="Доступ не оплачен"
            style={styles.iconImage}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const parent = e.currentTarget.parentElement;
              if (parent) {
                const fallback = document.createElement('div');
                fallback.textContent = '🔒';
                fallback.style.fontSize = '48px';
                fallback.style.opacity = '0.8';
                parent.appendChild(fallback);
              }
            }}
          />
        </div>
        <h2 style={styles.title}>Доступ ограничен</h2>
        <p style={styles.message}>
          Для использования всех возможностей платформы необходимо оплатить доступ.
          Свяжитесь с администратором или оплатите подписку.
        </p>
        <a href="mailto:info@hrlama.ru" style={styles.emailLink}>
          info@hrlama.ru
        </a>

        <button
          onClick={() => { window.location.href = '/payment'; }}
          style={styles.payButton}
        >
          💳 Оплатить подписку
        </button>

        <button onClick={onClose} style={styles.closeButtonBottom}>
          Закрыть
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.35)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  },
  modal: {
    background: 'rgba(255,255,255,0.75)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderRadius: 32,
    padding: 32,
    maxWidth: 420,
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 25px 45px rgba(0,0,0,0.15)',
    border: '1px solid rgba(255,255,255,0.5)',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    background: 'rgba(255,255,255,0.5)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: '1px solid rgba(255,255,255,0.5)',
    borderRadius: 30,
    width: 36,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#666',
    transition: 'all 0.2s',
  },
  icon: {
    marginBottom: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconImage: {
    width: 72,
    height: 72,
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    marginBottom: 12,
    background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  message: {
    fontSize: 15,
    color: '#4a4a68',
    marginBottom: 20,
    lineHeight: 1.5,
  },
  emailLink: {
    display: 'inline-block',
    fontSize: 15,
    color: '#2575fc',
    textDecoration: 'none',
    marginBottom: 24,
    fontWeight: 500,
    padding: '4px 0',
    borderBottom: '1px dashed rgba(37,117,252,0.5)',
    transition: 'border-bottom 0.2s',
  },
  payButton: {
    display: 'block',
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    color: 'white',
    border: 'none',
    borderRadius: 40,
    padding: '14px 24px',
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    width: '100%',
    boxShadow: '0 10px 20px rgba(34,197,94,0.35), 0 0 12px rgba(34,197,94,0.25)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    marginBottom: 10,
  },
  closeButtonBottom: {
    background: 'rgba(255,255,255,0.6)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    color: '#4a4a68',
    border: '1px solid rgba(255,255,255,0.7)',
    borderRadius: 40,
    padding: '10px 24px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s',
  },
};

export default PaymentRequiredModal;